// Smart nudge messages for different rule types
export const VALIDATION_NUDGES = {
    'Max Risk Per Trade': 'Checking your risk limits...',
    'Maximum Risk': 'Checking your risk limits...',
    'MaxRisk': 'Checking your risk limits...',
    'Minimum R:R': 'Analyzing reward-to-risk ratio...',
    'Min R:R': 'Analyzing reward-to-risk ratio...',
    'MinRR': 'Analyzing reward-to-risk ratio...',
    'Trend Alignment': 'Analyzing market trend on higher timeframes...',
    'Key Level Proximity': 'Checking nearby support and resistance levels...',
    'News/Event Context': 'Scanning economic calendar for upcoming events...',
    'Event Proximity': 'Scanning economic calendar for upcoming events...',
    'Liquidity Window': 'Checking market liquidity conditions...',
    'Volatility': 'Analyzing current market volatility...',
    'Extension': 'Checking price extension levels...',
    'default': 'Validating your trade...'
};

// Get smart nudge message for a rule
export const getNudgeMessage = (ruleName) => {
    if (!ruleName) return VALIDATION_NUDGES.default;

    // Try exact match first
    if (VALIDATION_NUDGES[ruleName]) {
        return VALIDATION_NUDGES[ruleName];
    }

    // Try partial match
    const lowerName = ruleName.toLowerCase();
    if (lowerName.includes('risk')) return VALIDATION_NUDGES['Max Risk Per Trade'];
    if (lowerName.includes('r:r') || lowerName.includes('reward')) return VALIDATION_NUDGES['Minimum R:R'];
    if (lowerName.includes('trend')) return VALIDATION_NUDGES['Trend Alignment'];
    if (lowerName.includes('level') || lowerName.includes('support') || lowerName.includes('resistance')) return VALIDATION_NUDGES['Key Level Proximity'];
    if (lowerName.includes('news') || lowerName.includes('event') || lowerName.includes('calendar')) return VALIDATION_NUDGES['News/Event Context'];
    if (lowerName.includes('liquidity')) return VALIDATION_NUDGES['Liquidity Window'];
    if (lowerName.includes('volatility') || lowerName.includes('atr')) return VALIDATION_NUDGES['Volatility'];
    if (lowerName.includes('extension')) return VALIDATION_NUDGES['Extension'];

    return VALIDATION_NUDGES.default;
};
